"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsSystem = void 0;
var system_1 = require("./system");
var uuid_1 = require("uuid");
var UtilsSystem = /** @class */ (function (_super) {
    __extends(UtilsSystem, _super);
    function UtilsSystem() {
        var _this = _super.call(this, [], []) || this;
        _this.systemName = "UtilsSystem";
        _this.gameStepEndCallbacks = [];
        _this.gameLogs = [];
        return _this;
    }
    /**
     * Logs a given value
     */
    UtilsSystem.prototype.log = function (value) {
        console.log("[LOG SYSTEM]: ".concat(value));
        this.gameLogs.push({
            id: (0, uuid_1.v4)(),
            value: value,
            time: Date.now(),
        });
    };
    UtilsSystem.prototype.queueAtGameStepEnd = function (callback) {
        this.gameStepEndCallbacks.push(callback);
    };
    UtilsSystem.prototype.onGameStepEnd = function (delta, realm) {
        var e_1, _a;
        try {
            for (var _b = __values(this.gameStepEndCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var callback = _c.value;
                callback();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.gameStepEndCallbacks = [];
        var currentLogs = this.gameLogs;
        this.gameLogs = [];
        this.dispatch("onProcessLogs", currentLogs);
    };
    return UtilsSystem;
}(system_1.System));
exports.UtilsSystem = UtilsSystem;
